// Vanilla reimplementation of Bootstrap 4's tooltip API, scoped to the theme's only usages:
// the two data-toggle="tooltip" data-placement="top" info icons in add-payment-method-modal.twig.
// Reuses the existing .tooltip/.bs-tooltip-top/.arrow/.tooltip-inner CSS already shipped in
// static/src/lib/bootstrap.css. No Popper dependency — both usages are fixed top placement, so no
// dynamic-flip positioning is needed.

let activeTooltip = null;
let activeTrigger = null;

function showTooltip(trigger) {
    if (activeTrigger === trigger) return;
    hideTooltip();

    const title = trigger.getAttribute('title');
    if (!title) return;

    const tooltip = document.createElement('div');
    tooltip.className = 'tooltip bs-tooltip-top';
    tooltip.setAttribute('role', 'tooltip');
    tooltip.innerHTML = '<div class="arrow"></div><div class="tooltip-inner"></div>';
    tooltip.querySelector('.tooltip-inner').textContent = title;

    document.body.appendChild(tooltip);

    const triggerRect = trigger.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    tooltip.style.left = `${triggerRect.left + window.scrollX + (triggerRect.width - tooltipRect.width) / 2}px`;
    tooltip.style.top = `${triggerRect.top + window.scrollY - tooltipRect.height}px`;
    tooltip.classList.add('show');

    activeTooltip = tooltip;
    activeTrigger = trigger;
}

function hideTooltip() {
    if (activeTooltip) activeTooltip.remove();
    activeTooltip = null;
    activeTrigger = null;
}

document.addEventListener('mouseover', (event) => {
    const trigger = event.target.closest('[data-toggle="tooltip"]');
    if (trigger) showTooltip(trigger);
});

document.addEventListener('mouseout', (event) => {
    const trigger = event.target.closest('[data-toggle="tooltip"]');
    if (trigger) hideTooltip();
});

document.addEventListener('focusin', (event) => {
    const trigger = event.target.closest('[data-toggle="tooltip"]');
    if (trigger) showTooltip(trigger);
});

document.addEventListener('focusout', (event) => {
    const trigger = event.target.closest('[data-toggle="tooltip"]');
    if (trigger) hideTooltip();
});
